
import React, {useContext, useEffect} from 'react';
import {customerShipmentList, TableColumn, TableSettings} from "../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../common/AbstractListView";
import constants from '../../constants';
import Select from "../../ui/Select";
import { Search} from "../../filtering";
import {DateRenderer,DateTimeRenderer,FloatRenderer,TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer} from '../../uiControls/SmartTableRenderers';
import ApplicationContext from '../../ApplicationContext';
import JobListViewContext, {RightClickContext } from '../common/JobListViewContext';
import {JobNames} from "../../framework.core/JobNames";
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';
import {  changeRQEvent, LastEventRenderer, RQFilterEventRenderer, RQFilterRenderer } from '../common/commonListRenderers';
import * as XCol from '../../framework.core/XExportColumn';
import { SuntekSettings, SystemSettings } from '../../ifmsTypes';
import _ from 'lodash';
import { Decimalformat, displayLastTrackingEvent } from '../common/commonExportFormat';
import { CustomerShipmentListItem } from '../../fms.data/models/CustomerShipmentListItem';
import { customerShipmentInfoStatus, ExportStatusBackColor, shipmentStatus } from './ShipmentStatus';
import LeftRightSplit from '../../ui/LeftRightSplit';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import CompanyLookupField from '../../uiControls/lookup/CompanyLookupField';
import CheckBox from '../../ui/CheckBox';
import cntrBlue from '../../img/cntr-tracking-rq-12-blue.svg';
import cntrGreen from '../../img/cntr-tracking-rq-12-green.svg';

function ListCommands() {
  return <></>;
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<CustomerShipmentListItem>) {
  return data.map((d: CustomerShipmentListItem, i) => ({
    ...d,
    id: i+1,  //only UI
  }));
}

interface companyFilter {
  companyId: number;
  companyName: string;
}

function AfterMemoLogButtonCommands() {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [listFilter, setListFilter, ] = useTypedFastStorage<companyFilter>('shipStatus-cust-ListFilter', {companyId: 0, companyName: ''});
  const [listStatusFilter, setListStatusFilter] = useTypedFastStorage<number>('shipStatus-status-ListFilter', 0);
  const [listTrackingFilter, setListTrackingFilter] = useTypedFastStorage<number>('shipStatus-tracking-ListFilter', 0);
  const [listBLTypeFilter, setListBLTypeFilter] = useTypedFastStorage<number>('shipStatus-blType-ListFilter', 0);
 
  useEffect(() => {
    changeShipListItem(listFilter || {companyId: 0, companyName: ''});
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [listFilter?.companyId]);

  useEffect(() => {
    changeShipListStatusItem(listStatusFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [ listStatusFilter]);

  useEffect(() => {
    changeShipListTrackingItem(listTrackingFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [ listTrackingFilter]);

  useEffect(() => {
    changeShipListBLTypeItem(listBLTypeFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [ listBLTypeFilter]);

  function changeShipListItem(listFilter: companyFilter){
    jobListContext.setListFilterType(listFilter.companyId);
  }

  function changeShipListStatusItem(listStatusFilter: number){
    jobListContext.setListFilterType2(listStatusFilter);
  }

  function changeShipListTrackingItem(listTrackingFilter: number){
      jobListContext.setListFilterType3(listTrackingFilter);
  }

  function changeShipListBLTypeItem(listBLTypeFilter: number){
      jobListContext.setListFilterType4(listBLTypeFilter);
  }
  
  function checkBlank(){
    if(listFilter?.companyName === '') {
      setListFilter({companyId: 0});
    }
  }
  

  return (
    <>

      <div style={{marginLeft:'10px', marginTop:'10px', width:'110px',display:'inline-block'}}>
        <LeftRightSplit
          leftSize={'40px'}
          rightSize={'60px'}
          left={<label style={{color: appContext.useDarkMode ? 'white': 'black',lineHeight:'16px'}}>Type</label> }
          right={
            <div style={{lineHeight:'14px', maxHeight:'300px',}}>
            <Select
              name="ifms-custship-list-type-filter"
              value={listBLTypeFilter ?? 0}
              items={[
                {value: 0, label: 'OI'},
                {value: 1, label:'OE'},
                {value: 2, label:'OT'},
              ]}
            onChange={e => {setListBLTypeFilter(Number(e.target.value))}}
            />
            </div>
          }
        />
      </div>

      <div style={{marginLeft:'10px', marginTop:'10px', width:'260px',display:'inline-block'}}>
        <LeftRightSplit
          leftSize={'70px'}
          rightSize={'180px'}
          left={<label style={{color: appContext.useDarkMode ? 'white': 'black',lineHeight:'16px'}}>Customer</label> }
          right={
            
            <CompanyLookupField 
              placeholder='Blank for All'
              //lookupId='id-ifms-custship-list-company-filter'
              //name='ifms-custship-list-company-filter'
              initialValue={listFilter?.companyName ?? ''}
              onFocus = {e=>e.target.select()}
              onTextChange={shortName => {
              setListFilter({companyName: shortName});
              checkBlank();
              }}
              onSelect={company => {setListFilter({companyId: company.id, companyName: company.shortName??''})}}
              />
          }
        />
      </div>
      <div style={{marginLeft:'10px', marginTop:'10px', width:'300px',display:'inline-block'}}>
        <LeftRightSplit
          leftSize={'100px'}
          rightSize={'180px'}
          left={<label style={{color: appContext.useDarkMode ? 'white': 'black',lineHeight:'16px'}}>Shipment Status</label> }
          right={
            <div style={{lineHeight:'14px', maxHeight:'300px',}}>
            <Select
              name="ifms-custship-list-status-filter"
              value={listStatusFilter ?? 0}
              items={[
                {value: 0, label: 'ALL'},
                {value: 1, label:'NOT DEPARTED', color: `#${customerShipmentInfoStatus[shipmentStatus.NotDeparted].color}`},
                {value: 2, label:'VESSEL DEPARTURE', color: `#${customerShipmentInfoStatus[shipmentStatus.VesselDeparture].color}`},
                {value: 3, label:'VESSEL ARRIVAL', color: `#${customerShipmentInfoStatus[shipmentStatus.VesselArrival].color}`},
                {value: 4, label:'PICKUP AVAILABLE', color: `#${customerShipmentInfoStatus[shipmentStatus.PickupAvailable].color}`},
                {value: 5, label:'GATE OUT', color: `#${customerShipmentInfoStatus[shipmentStatus.GateOut].color}`},
                {value: 6, label:'EMPTY CNTR RETURN', color: `#${customerShipmentInfoStatus[shipmentStatus.EmptyCntrReturn].color}`},
              ]}
            onChange={e => {setListStatusFilter(Number(e.target.value))}}
            />
            </div>
          }
        />
      </div>
      <div style={{marginTop:'10px', width:'130px',display:'inline-block'}}>
        <LeftRightSplit
          leftSize={'90px'}
          rightSize={'20px'}
          left={<label style={{color: appContext.useDarkMode ? 'white': 'black',lineHeight:'16px'}}>Tracking Only</label> }
          right={
            <div style={{lineHeight:'16px', maxHeight:'300px'}}>
              <CheckBox  value={listTrackingFilter === 1} onChange={checked => setListTrackingFilter(checked ? 1 : 0) } backColor={true} dark={appContext.useDarkMode} />
            </div>
          }
        />
      </div>
    </>
  )
}

/**
 * Concrete implementation for Other Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {

    const apiResult = await api.getListItems(
      JobNames.RptCustomerShipment,
      'CustomerShipmentListItem',
      CustomerShipmentListItem.calculateSearchParameters(search, CustomerShipmentListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }


  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.RptCustomerShipment, 'CustomerShipmentListItem',
      CustomerShipmentListItem.calculateSearchParameters(search, CustomerShipmentListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return   formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'trStatus',
        renderer: RQFilterEventRenderer,
        searchValueExtractor: (v:any|null|undefined) => v !== null ? changeRQEvent(v): "",
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean): ListRowRenderer[] {
    return CustomerShipmentListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.RptCustomerShipment} />;
        colRenderer.Header =  () => <div style={{gap:'4px', display:'flex'}}><img src={useDarkMode ? cntrGreen: cntrBlue} alt='' /><div>Container Tracking</div></div>;
      }
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
    colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return Decimalformat(value['lbs'],2) } });
    colRenderer.push({ accessor: 'kgs', changedValue: (value: any) => { return Decimalformat(value['kgs'],2) } });
    colRenderer.push({ accessor: 'trStatus', changedValue: (value: any) => { return displayLastTrackingEvent(value) }, backgroundColor: (value: any) => { return ExportStatusBackColor('lastEvent', value) } });
    return colRenderer;
  }

  getDefaultOrderBy(search:any): ListOrderBy {
    if(search){
      if(search.listType4 === 1){
        return {
        orderBy: 'etd',
        orderByAscending: false,
      };
      } else {
        return {
          orderBy: 'eta',
          orderByAscending: false,
        };
      }
    } else {
      return {
        orderBy: 'eta',
        orderByAscending: false,
      };
    }
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  customerShipmentList;
    const cols = CustomerShipmentListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return  <></>;//<ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: CustomerShipmentListItem) {
    return '';
  }

  getListViewTitle() {
    return 'Shipment Control Tower';
  };

  renderAdditionalCommands() {
    return <></>;
  }

  hasRightClickContext(): boolean {
    return false;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return null;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <></>;
  }
  
  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default ListView;
